import React, { Component, Fragment } from 'react';
import { Form, FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import withValidator from '../../../models/form/withValidator';
import LoadingButton from '../../../../shared/ui/LoadingButton';

const validatorConfig = {
  cssClasses: {
    fieldInvalid: 'is-invalid',
    fieldValid: 'is-valid',
  },
  fields: {
    label: {
      rules: [
        {
          feedback: 'Label is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
    phoneNumber: {
      rules: [
        {
          feedback: 'Phone number is required',
          test(value) {
            return !!value;
          },
        },
        {
          feedback: 'Phone format is not valid',
          test(value) {
            return !!value.match(/^\(?[2-9]\d{2}\)?[ -]?[2-9]\d{2}-?\d{4}$/);
          },
        },
      ],
    },
  },
};

class PhoneForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cssValidationClasses: {
        label: '',
        phoneNumber: '',
      },
      errorFeedback: {},
      isDefault: !this.props.initialValues
        ? false
        : this.props.initialValues.isDefault,
      isFormDisabled: true,
      label: !this.props.initialValues ? '' : this.props.initialValues.label,
      phoneNumber: !this.props.initialValues
        ? ''
        : this.props.initialValues.phoneNumber,
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.initialValues) {
      this.props.initialize({
        label: this.state.label,
        phoneNumber: this.state.phoneNumber,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cssValidationClasses: nextProps.cssValidationClasses,
      errorFeedback: nextProps.errorFeedback,
      isFormDisabled: this.getIsFormInvalid(
        nextProps.hasErrors,
        nextProps.hasUntouched,
      ),
    });
    if (
      nextProps.initialValues &&
      !Object.is(this.props.initialValues, nextProps.initialValues)
    ) {
      this.setState({
        isDefault: nextProps.initialValues.isDefault,
        label: nextProps.initialValues.label,
        phoneNumber: nextProps.initialValues.phoneNumber,
      });
    }
  }

  // ----------------------
  // Methods
  // ----------------------

  getIsFormInvalid(hasErrors, hasUntouched) {
    return hasErrors || hasUntouched;
  }

  handleBlur(event) {
    const { name, value } = event.target;
    this.props.touch(name);
    this.props.validateField(name, value);
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () =>
      this.props.validateField(name, value, true));
  }

  handleSubmit(e) {
    e.preventDefault();
    const regex = /[()\s-]/g;
    const properties = {
      countryCode: '1',
      isDefault: this.state.isDefault,
      label: this.state.label,
      phoneNumber: this.state.phoneNumber.replace(regex, ''),
    };
    this.props.onSave(properties);
  }

  render() {
    return (
      <Fragment>
        <Form
          className="m-3"
          noValidate
          onSubmit={event => this.handleSubmit(event)}
        >
          <FormGroup>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <Label for="label">
              Label <i className="fa fa-asterisk" />
            </Label>
            <Input
              autoComplete="off"
              className={this.state.cssValidationClasses.label}
              id="label"
              name="label"
              onBlur={event => this.handleBlur(event)}
              onChange={event => this.handleInput(event)}
              placeholder="Label"
              type="text"
              value={this.state.label}
            />
            <FormFeedback>{this.state.errorFeedback.label}</FormFeedback>
          </FormGroup>
          <FormGroup>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <Label for="phoneNumber">
              Phone Number <i className="fa fa-asterisk" />
            </Label>
            <Input
              autoComplete="off"
              className={this.state.cssValidationClasses.phoneNumber}
              id="phoneNumber"
              name="phoneNumber"
              onBlur={event => this.handleBlur(event)}
              onChange={event => this.handleInput(event)}
              placeholder="Phone Number"
              type="text"
              value={this.state.phoneNumber}
            />
            <FormFeedback>{this.state.errorFeedback.phoneNumber}</FormFeedback>
          </FormGroup>
          <div style={{ textAlign: 'right' }}>
            <LoadingButton
              primary
              isLoading={this.props.isLoading}
              text="Submit"
              disabled={this.state.isFormDisabled}
            />
          </div>
        </Form>
      </Fragment>
    );
  }
}

export default withValidator(PhoneForm, validatorConfig);
